"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uint8ArrayEq = exports.lexCompare = void 0;
function lexCompare(a, b) {
    var min = a.length < b.length ? a : b;
    var minLen = min.length;
    for (var i = 0; i < minLen; i++) {
        var _a = a.at(i);
        var _b = b.at(i);
        if (_a === undefined)
            return -1 /* Ord.LT */;
        if (_b === undefined)
            return 1 /* Ord.GT */;
        if (_a < _b)
            return -1 /* Ord.LT */;
        if (_a > _b)
            return 1 /* Ord.GT */;
        // if( _a === _b ) continue;
    }
    return a.length === b.length ? 0 /* Ord.EQ */ :
        (a.length < b.length ? -1 /* Ord.LT */ : 1 /* Ord.GT */);
}
exports.lexCompare = lexCompare;
function uint8ArrayEq(a, b) {
    return a.length === b.length && a.every(function (n, i) { return n === b[i]; });
}
exports.uint8ArrayEq = uint8ArrayEq;
